<div class="form-container">    
    <div class="inline">
        <button pButton type="button" label="Add Asset Group" *ngIf="showAddButton" (click)="showAddDialog()"></button>
    </div>  
</div>
<br>

<p-table [value]="partnershipDataGroupList" autoLayout=true [paginator]="paginator" [loading]="loading" [rows]="rows" [rowsPerPageOptions]="rowsPerPageOptions">
  <ng-template pTemplate="header">
    <tr>
      <th [pSortableColumn]="'RelationshipDataGroup.RelationshipGroupName'">Asset Group Name <p-sortIcon [field]="'RelationshipDataGroup.RelationshipGroupName'"></p-sortIcon></th>
      <th [pSortableColumn]="'Company.Name'">Partnership <p-sortIcon [field]="'Company.Name'"></p-sortIcon></th>
      <th>User Count</th>
      <th>Asset IDs</th>
      <th>Actions</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-partnershipDataGroup>
    <tr>
      <td>{{partnershipDataGroup.RelationshipDataGroup.RelationshipGroupName}}</td>
      <td>{{partnershipDataGroup.Company.Name}}</td>
      <td>{{partnershipDataGroup.UserCount}}</td>
      <td>
          <span *ngIf="partnershipDataGroup.AssetIdList.length < 5">{{partnershipDataGroup.AssetIdList}}</span>
          <span *ngIf="partnershipDataGroup.AssetIdList.length > 5">{{partnershipDataGroup.AssetIdList.slice(0,5).join(', ')}} 
            <i class="hoverLink" (mouseover)="displayAssetIds(op, $event, partnershipDataGroup)" (mouseout)="op.hide($event)">+More</i>
          </span>
      </td>
      <td>
          <div *ngIf="partnershipWithMasterGroup.indexOf(partnershipDataGroup.RelationshipDataGroup.RelationshipId) >= 0">          
            <i class="pi pi-fw pi-pencil action" (click)="edit(partnershipDataGroup)" *ngIf="!loading"></i>
            <i class="pi pi-fw pi-trash action" (click)="delete(partnershipDataGroup)" *ngIf="!loading"></i>            
          </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="paginatorright" let-state>
    Showing {{state.first}} to {{state.first+state.rows}} of {{state.totalRecords}} entries
  </ng-template>
</p-table>
<p-overlayPanel #op [dismissable]="true">
  <div *ngIf="partnershipDataGroupSelected">
      {{partnershipDataGroupSelected.AssetIdList.join(', ')}}
  </div>
</p-overlayPanel>
<app-add-asset-group [displayDialog]="displayAddDialog" (onDialogHide)="addDialogHide($event)" (onAdd)="onAdd($event)" *ngIf="displayAddDialog"></app-add-asset-group>
<app-edit-asset-group [displayDialog]="displayEditDialog" (onDialogHide)="editDialogHide($event)" (onEdit)="onEdit($event)" *ngIf="displayEditDialog && partnershipDataGroupSelected" [partnershipDataGroup]="partnershipDataGroupSelected"></app-edit-asset-group>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" *ngIf="partnershipDataGroupList"></p-confirmDialog>